import React from 'react';
import Table from './table';

import Busy from '../busy';

const TableWithBusy = (props) => <Table busy={Busy} {...props} />;

export { Table };
export default TableWithBusy;
